<template>
    <div class="row h-100 justify-content-center align-items-center bg-danger text-light">
        <div class="col-11 col-sm-8" v-if="$route.params.pin">
            <h1>Ingrese sus datos</h1>
            <input type="text" class="form-control form-control-lg mt-4" v-model="user.nombre" placeholder="Nombre">
            <input type="email" class="form-control form-control-lg mt-4" v-model="user.email" placeholder="Email">
            <input type="text" class="form-control form-control-lg mt-4" v-model="user.position" placeholder="Puesto">
            <button class="btn btn-light btn-lg mt-4" :disabled="disabled" @click="start">Registrarse</button>
        </div>
        <h3 v-else>No se ha definido pin</h3>
    </div>
</template>

<script>
import router from "../router";
import axios from "axios";
import { mapActions } from "vuex";

export default {
    data() {
        return {
            loading: false,
            user: {
                usuarioid: null,
                nombre: null,
                email: null,
                position: null,
            },
        };
    },
    computed: {
        disabled: function () {
            return this.user.nombre === null || this.user.email === null;
        },
    },
    methods: {
        start() {
            this.loading = true;

            axios
                .post("/api/agility/register", {
                    evaluation: this.$route.params.pin,
                    user: this.user,
                })
                .then((res) => {
                    this.setUser(res.data.user);
                    this.setEvaluation(res.data.evaluation);
                    this.clearAnswers();
                    this.clearAnnexes();

                    router.push({ name: "Instructions" });
                })
                .catch((err) => {
                    alert(err.response.data.message);
                    this.loading = false;
                });
        },
        ...mapActions([
            "clearAnswers",
            "clearAnnexes",
            "setUser",
            "setEvaluation",
        ]),
    },
};
</script>

<style>
</style>
